<template>
	<div class="weui-tab single-page-wrap">
		<div class="weui-navbar">
			<div v-for="(item, index) of navBarList" :key="item.id" class="weui-navbar__item"
				:class="navItemIdx === index ? 'weui-bar__item_on' : ''" @click="handleNavBar(item.id, index)">{{ item.name }}
			</div>
		</div>
		<div class="attention-wrap">
			<i class="iconfont icon-zhuyi"></i>
			<p class="attention-text">注意: 只能选择相同停车场下的订单进行开票(如果开票遇到问题请联系：18913530736)</p>
		</div>
		<cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions" :scrollEvents="['scroll']"
			@scroll="getScrollHeight">
			<div v-if="feeList.length > 0">
				<div class="weui-cells__group weui-cells__group_form">
					<div class="weui-cells weui-cells_checkbox">
						<div class="weui-cell weui-check__label" :for="item.id" v-for="item of feeList"
							@click="handleCheckedOption(item)">
							<div class="weui-cell__hd"
								:style="(item.ticketOut == 1||item.ticketOut == 2 || item.status != 1 || !item.parkinglotId) ? 'visibility: hidden' : ''">
								<input type="checkbox" class="weui-check" name="checkbox" :checked="item.checked"
									:id="item.id" :disabled="(parkinglotId && item.parkinglotId != parkinglotId)" />
								<i class="weui-icon-checked"></i>
							</div>
							<div class="weui-cell__bd">
								<p style="display: flex; justify-content: space-between">
									<span>{{ item.payTime || '订单未支付' }}</span>
									<span style="font-size: 12px">{{ item.goodsTypeName }} | {{ item.ticketOut == 1 ? "已开票" :item.ticketOut == 2?"不支持开票" :"未开票" }}</span>
								</p>
								<p style="display: flex; justify-content: space-between;align-items: center">
									<span style="font-size: 14px">{{ item.parkName || '暂无' }}</span>
									<span
										style="font-size: 20px;font-weight: 400;color: #000000">{{ item.totalPrice }}元</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<no-data v-else msg="暂无"></no-data>
		</cube-scroll>
		<div class="weui-btn-area">
			<button class="weui-btn weui-btn_primary" :class="!isCheckedOrderSn ? 'weui-btn_disabled' : ''"
				:disabled="!isCheckedOrderSn" @click="next">下一步</button>
		</div>
	</div>
</template>

<script>
import { getUserParkingFeeList,getParkinglotConfigInfo } from "../../../api/coupon/userParkingFeeList";
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: "userParkingFeeList",
	data() {
		return {
			isOpenInvoices: "",
			receiptCheckedOrderSnObj: {},
			parkinglotId: undefined,
			isCheckedOrderSn: false,
			timeSwitch: undefined,
			navItemIdx: 0,
			navBarList: [
				{ id: 1, name: '七天' },
				{ id: 2, name: '一个月' },
				{ id: 3, name: '四个月' },
			],
			scrollOptions: {
				click: true,
				bounce: false
			},
			goodsTypeOptions: {
				1: "充值余额",
				2: "出口缴费",
				3: "场内支付",
				4: "商家购买停车券",
				5: "普通用户购买停车券"
			},
			feeList: [],
			feeObj: {},
			scrollHeightObj: {
				0: 0,
				1: 0,
				2: 0
			},
			totalPrice: 0.00
		}
	},
	computed: {
		...mapGetters(['userOpenid', 'receiptInfo', 'receiptParkinglotId'])
	},
	created() {
		this.timeSwitch = this.navBarList[0].id;
		this.getUserParkingFeeList()
	},
	methods: {
		...mapMutations({
			setOrderSn: 'SET_ORDERSN',
			setTotalPrice: 'SET_TOTAL_PRICE',
			setReceiptOrderSnObj: "SET_RECEIPT_ORDERSN_OBJ",
			setReceiptParkinglotId: "SET_RECEIPT_PARKINGLOTID",

		}),
		/** 切换导航操作*/
		handleNavBar(id, index) {
			this.timeSwitch = id;
			this.navItemIdx = index;
			this.getUserParkingFeeList();
		},
		getUserParkingFeeList() {
			let form = {
				openid: localStorage.getItem('userOpenId')||this.userOpenid  ,
				timeSwitch: this.timeSwitch
			};
			getUserParkingFeeList(form).then(res => {

				// this.isOpenInvoices = res.data[0].isOpenInvoices
				// this.isOpenInvoices = 0
				let feeList = res.data || [];
				if (feeList.length > 0) {
					feeList.map(item => {
						if (this.goodsTypeOptions[item.goodsType]) {
							this.$set(item, 'goodsTypeName', this.goodsTypeOptions[item.goodsType])
						}
						item.totalPrice = parseFloat(item.totalPrice).toFixed(2);
						if (this.receiptCheckedOrderSnObj[item.id]) {//是否在切换导航时已选择过此项
							this.$set(item, 'checked', true)
						} else {
							this.$set(item, 'checked', false)
						}
					});
					this.$refs.scroll.scrollTo(0, parseInt(this.scrollHeightObj[this.navItemIdx]), 200);

				} else {
					this.$refs.scroll.scrollTo(0, 0, 200);
					this.isCheckedOrderSn = false;
				}
				this.$set(this.feeObj, this.navItemIdx, feeList);
				this.feeList = feeList;
				this.$nextTick(() => {
					this.$refs.scroll.refresh()
				});
			})
		},
		/** 点击列表单个项操作*/
		handleCheckedOption(item) {
			console.log(item,'465456456');
			
			if (item.ticketOut == 1 || item.status != 1 || !item.parkinglotId) return;
			if (item.checked) {
				item.checked = false;
				delete this.receiptCheckedOrderSnObj[item.id];
				this.totalPrice -= Number(item.totalPrice);
			} else {
				if (Object.keys(this.receiptCheckedOrderSnObj).length <= 0) {
					this.parkinglotId = undefined
				}
				// this.parkinglotId = 26

				if (!this.parkinglotId) {
					console.log('选择不存在');
					item.checked = true;
					this.receiptCheckedOrderSnObj[item.id] = item.orderSn;
					this.isCheckedOrderSn = true;
					this.totalPrice += Number(item.totalPrice);
					this.parkinglotId = item.parkinglotId;
				} else {//存在
					if (this.parkinglotId === item.parkinglotId) {//相同停车场
						console.log('选择存在');
						item.checked = true;
						this.receiptCheckedOrderSnObj[item.id] = item.orderSn;
						this.isCheckedOrderSn = true;
						this.totalPrice += Number(item.totalPrice);
					}
				}
			}
			if (Object.keys(this.receiptCheckedOrderSnObj).length > 0) {
				this.isCheckedOrderSn = true;
			} else {
				this.isCheckedOrderSn = false;
			}
		},
		/** 获取滚动的高度*/
		getScrollHeight(e) {//记录每个导航滑动的高度 用户再切换进来时自动滚动到上一次的地方
			this.scrollHeightObj[this.navItemIdx] = e.y;
		},
		next() {
			let feeParams = []
			
			for (let index = 0; index < this.feeList.length; index++) {
				if (this.feeList[index].checked) {
					feeParams.push(this.feeList[index])
				}
				
			}
			console.log(feeParams,'feeParams');
			
			const allZeros = feeParams.every(item => item.isOpenInvoices === 1);
			if (!allZeros) {
				this.$weui.alert('未开启电子发票')
			} else {
				this.setReceiptParkinglotId(this.parkinglotId);
				this.setTotalPrice(parseFloat(this.totalPrice).toFixed(2));
				this.setReceiptOrderSnObj(this.receiptCheckedOrderSnObj);
				
				getParkinglotConfigInfo(this.parkinglotId).then(res=>{
					console.log(res,'获取开票信息');
					if (res.code==200) {

						// return
						this.$router.push({ name: 'receiptForWrite', params: { receiptType: 1,type:res.data.type } })
					}
				})
				
				
			}

		}
	}
}
</script>

<style scoped lang="stylus">
	@import "../../../common/stylus/variable.styl"
	.weui-tab{
		.weui-tab-panel{
			padding 30px 10px 10px 10px
			display flex
			flex-wrap wrap
			justify-content space-between
			.fee-item-wrapper{
				color #B6B6B6
				width 48%
				height 105px
				padding 10px 0
				margin-bottom 15px
				box-shadow 0 0 6px #ddd
				border-radius 10px
				overflow hidden
				display flex
				flex-direction column
				align-items center
				position relative
				h6{
					font-weight 600
				}
				p{
					font-size 12px
					line-height 16px
				}
				.effect-date-wrapper{
					padding: 2px 0;
					border-top: 1px dashed #eee;
					position absolute
					left 0
					right 0
					bottom 0
					p{
						font-size 10px
						text-align center
						line-height 14px
					}
				}
				.active{
					background-color rgba(255,255,255,.5)
				}
			}
			.active{
				color #fff
				background-color #07c160
			}
		}
		.cube-scroll {
			position: relative;
			text-align: left;
			white-space: normal;
			max-height: 75%
			overflow hidden
			background: #ffffff;
			/*margin-bottom 20px*/
			.no-data-wrap {
				padding-top 25%
				display flex
				justify-content center
				align-items center
				.weui-article{
					color $no-data-font-color
					h1{
						font-size $no-data-font-size
					}
				}
			}
			.weui-form__control-area{
				margin-top 0
			}
			.weui-cells:before{
				border-top none
			}
			.weui-cells__group_form .weui-cell{
				padding  16px
			}
		}
		.weui-btn-area{
			margin 10px
			.weui-btn{
				width: 100%;
			}
		}
		.attention-wrap{
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 8px;
			border-bottom: 1px solid #ccc;
			box-shadow: 0 0 20px #ccc;
			background-color: #ECECEC
			.icon-zhuyi{
				font-size: 13px;
				padding-right: 5px;
				color: #FFAE02
			}
			.attention-text{
				font-size 13px
				letter-spacing 1px
			}
		}
	}
</style>
